import { render, staticRenderFns } from "./MenuUserNotifications.vue?vue&type=template&id=0c58a284&scoped=true"
import script from "./MenuUserNotifications.vue?vue&type=script&lang=js"
export * from "./MenuUserNotifications.vue?vue&type=script&lang=js"
import style0 from "./MenuUserNotifications.vue?vue&type=style&index=0&id=0c58a284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58a284",
  null
  
)

export default component.exports